/**
 * Stable identifier for a Library row regardless of origin. Attachment rows
 * use `artifactId` (the api-side artifact UUID); upload rows have null
 * `artifactId` and fall back to `id` (project_file.id).
 *
 * Centralized so every consumer iterating the merged list (grid, picker,
 * preview-modal navigation) keys rows the same way. If a future change ever
 * produces a row with neither, this is the single place to log + decide.
 */
export function getArtifactRowKey(row: {
  artifactId?: string | null | undefined;
  id: string;
}): string {
  return row.artifactId ?? row.id;
}
